export default __webpack_public_path__ + "static/media/a4.eeceb944.png";